module.exports = __webpack_public_path__ + "media/images/maximize-square-plus-01035341f698db71416ef8c242a4890b.png";